function getDictLabel(list,id){
    let label
    for (let i = 0; i < list.length; i++) {
        const element = list[i];
        if(id == element.dictValue){
            label = element.dictLabel
        }
    }
    return label;
}
function baseURL(){
    return 'http://admin.cimomicro.com/prod-api'
}
function backPage(page){
    if(page == '-1'){
        this.$router.go(-1)
    }else{
        this.$router.push(page)
    }
}
export {getDictLabel,backPage}


// WEBPACK FOOTER //
// ./src/utils/common.js